import { render, staticRenderFns } from "./lkuCrewlazzy.vue?vue&type=template&id=7a8fa2ef&"
import script from "./lkuCrewlazzy.vue?vue&type=script&lang=js&"
export * from "./lkuCrewlazzy.vue?vue&type=script&lang=js&"
import style0 from "./lkuCrewlazzy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports